import { Routes, Route, Navigate } from 'react-router-dom';
import { Role } from '@avgrp/shared';
import { Layout } from '@/components/common/Layout';
import { ProtectedRoute } from '@/components/common/ProtectedRoute';
import { RoleGuard } from '@/components/common/RoleGuard';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { FlightsPage } from '@/pages/FlightsPage';
import { ResourcesPage } from '@/pages/ResourcesPage';
import { TasksPage } from '@/pages/TasksPage';
import { SchedulingPage } from '@/pages/SchedulingPage';
import { CostsPage } from '@/pages/CostsPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { UsersPage } from '@/pages/UsersPage';
import { GanttPage } from '@/pages/GanttPage';
import { AircraftTypesPage } from '@/pages/AircraftTypesPage';
import { FleetPage } from '@/pages/FleetPage';
import { AirportPage } from '@/pages/AirportPage';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        {/* Everyone */}
        <Route path="/" element={<DashboardPage />} />
        <Route path="/flights" element={<FlightsPage />} />
        <Route path="/gantt" element={<GanttPage />} />
        <Route path="/tasks" element={<TasksPage />} />
        <Route path="/scheduling" element={<SchedulingPage />} />

        {/* Supervisor+ */}
        <Route path="/resources" element={<RoleGuard minRole={Role.SUPERVISOR}><ResourcesPage /></RoleGuard>} />
        <Route path="/fleet" element={<RoleGuard minRole={Role.SUPERVISOR}><FleetPage /></RoleGuard>} />
        <Route path="/aircraft-types" element={<RoleGuard minRole={Role.SUPERVISOR}><AircraftTypesPage /></RoleGuard>} />
        <Route path="/airport" element={<RoleGuard minRole={Role.SUPERVISOR}><AirportPage /></RoleGuard>} />

        {/* Manager+ */}
        <Route path="/costs" element={<RoleGuard minRole={Role.MANAGER}><CostsPage /></RoleGuard>} />

        {/* Admin only */}
        <Route path="/settings" element={<RoleGuard minRole={Role.ADMIN}><SettingsPage /></RoleGuard>} />
        <Route path="/users" element={<RoleGuard minRole={Role.ADMIN}><UsersPage /></RoleGuard>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
